module.exports = __webpack_public_path__ + "media/images/category-land-0c05fc1c9015f5ebbd777209c620ccaa.jpg";